<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-checkerboard</v-icon>{{$t('profile.printingsurface.sizes')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <PrintingSurfaceSizeForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import PrintingSurfaceSizeForm from '../../components/printingsurfacesize/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'PrintingSurfaceSize';

const { mapFields } = createHelpers({
  getterType: 'printingsurfacesize/getField',
  mutationType: 'printingsurfacesize/updateField'
});

export default {
  name: 'PrintingSurfaceSizeCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    PrintingSurfaceSizeForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('printingsurfacesize', ['create', 'reset'])
  }
};
</script>
